import type { Size } from '../types'

export function FormatQuoteIcon({ className, size }: { className?: string; size: Size }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3778_2320"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect
          width="20"
          height="20"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_3778_2320)">
        <path
          d="M5.11877 14.7115L7.07564 11.3061C7.02759 11.3327 6.97148 11.3514 6.90731 11.3621C6.84314 11.3728 6.77905 11.3782 6.71502 11.3782C5.8678 11.3782 5.14849 11.0798 4.5571 10.4832C3.96585 9.88649 3.67023 9.16989 3.67023 8.33337C3.67023 7.48614 3.96585 6.76684 4.5571 6.17545C5.14849 5.5842 5.8678 5.28857 6.71502 5.28857C7.55155 5.28857 8.26814 5.5842 8.86481 6.17545C9.46148 6.76684 9.75981 7.48614 9.75981 8.33337C9.75981 8.62614 9.72432 8.89857 9.65335 9.15066C9.58224 9.40274 9.47828 9.64316 9.34148 9.87191L6.5546 14.7115H5.11877ZM12.5227 14.7115L14.4794 11.3061C14.4313 11.3327 14.3752 11.3514 14.3111 11.3621C14.247 11.3728 14.1829 11.3782 14.1188 11.3782C13.2715 11.3782 12.5523 11.0798 11.9611 10.4832C11.3697 9.88649 11.074 9.16989 11.074 8.33337C11.074 7.48087 11.3697 6.76024 11.9611 6.17149C12.5523 5.58288 13.2715 5.28857 14.1188 5.28857C14.9553 5.28857 15.6719 5.5842 16.2686 6.17545C16.8652 6.76684 17.1636 7.48614 17.1636 8.33337C17.1636 8.62614 17.1281 8.89857 17.0571 9.15066C16.986 9.40274 16.8821 9.64316 16.7454 9.87191L13.9586 14.7115H12.5227Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
